import { Role } from '@link/admin/constants';

interface NavItem {
  to: string;
  labelKey: string;
}

export const NAV_ITEMS: Record<Role, NavItem[]> = {
  [Role.Link]: [
    { to: '/link/dashboard', labelKey: 'views.dashboard.title' },
    { to: '/link/merchants', labelKey: 'views.merchants.title' },
    { to: '/link/documents', labelKey: 'views.documents.title' },
    { to: '/link/customers', labelKey: 'views.customers.title' },
    { to: '/link/agencies', labelKey: 'views.agencies.title' },
    { to: '/link/staffs', labelKey: 'views.staffs.title' },
    { to: '/link/notifications', labelKey: 'views.notifications.title' }
  ],
  [Role.MerchantAdmin]: [
    { to: '/merchant/dashboard', labelKey: 'views.dashboard.title' },
    {
      to: '/merchant/accountinfo',
      labelKey: 'views.accountInfo.merchantTitle'
    },
    { to: '/merchant/documents', labelKey: 'views.documents.title' },
    { to: '/merchant/staffs', labelKey: 'views.staffs.title' }
  ],
  [Role.MerchantStaff]: [
    { to: '/merchant/dashboard', labelKey: 'views.dashboard.title' },
    {
      to: '/merchant/accountinfo',
      labelKey: 'views.accountInfo.merchantTitle'
    },
    { to: '/merchant/documents', labelKey: 'views.documents.title' }
  ],
  [Role.ShopAdmin]: [
    { to: '/shop/dashboard', labelKey: 'views.dashboard.title' },
    { to: '/shop/accountinfo', labelKey: 'views.accountInfo.shopTitle' },
    { to: '/shop/staffs', labelKey: 'views.staffs.title' }
  ],
  [Role.ShopStaff]: [
    { to: '/shop/dashboard', labelKey: 'views.dashboard.title' },
    { to: '/shop/accountinfo', labelKey: 'views.accountInfo.shopTitle' }
  ]
};
